import React, { useState } from 'react'
import Pagination from '../Pagination'
import styles from './Carousel.module.css'

interface ComponentProps {
  index?: number
  className?: string
  children?: JSX.Element[] | undefined
  wrapperRef?: React.RefObject<HTMLElement>
  sectionTitle: string | undefined
}

function Carousel({
  children,
  wrapperRef,
  className,
  sectionTitle,
}: ComponentProps) {
  const [index, setIndex] = useState(0)

  if (!children) return null

  const styleTransform = index === 0 ? '' : `translateX(${index * -100}%)`
  return (
    <div className={styles.carousel}>
      <div className={`${className} ${styles['carousel-inner']}`}>
        {children.map((item, idx) => {
          return (
            <div
              className={styles['carousel-item-wrap']}
              key={idx}
              style={{ transform: styleTransform }}
            >
              {item}
            </div>
          )
        })}
      </div>
      {children.length > 1 && (
        <Pagination
          setIndex={setIndex}
          index={index}
          numberOfItems={children.length}
          sectionTitle={sectionTitle}
        />
      )}
    </div>
  )
}

export default Carousel
